import * as tslib_1 from "tslib";
// Third party components
import { FieldArrayType } from "@ngx-formly/core";
// Custom components
/**
 * Script start
 */
var RepeatScaleTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RepeatScaleTypeComponent, _super);
    function RepeatScaleTypeComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RepeatScaleTypeComponent;
}(FieldArrayType));
export { RepeatScaleTypeComponent };
